import React from "react"
import autobind from "class-autobind"
import { FloatingActionButton } from "material-ui"
import ContentAdd from "material-ui/svg-icons/content/add"
import strings from "../../localization/strings"
import { IAccrualAdjustment } from "../../models"
import * as utils from "../../helpers/utils"
import AppStateStore from "../../stores/AppStateStore"
import TableActionBar from "../../components/layout/TableActionBar"
import AdjustmentsTable from "./AdjustmentsTable"
import AdjustmentDialog from "./AdjustmentDialog"

interface IProps {
    readonly: boolean
    adjustments: IAccrualAdjustment[]
    addOrUpdateAdjustment(adjustment: IAccrualAdjustment, update: boolean): void
    deleteAdjustment(adjustmentIds: string[]): void
}

interface IState {
    adjustments: IAccrualAdjustment[]
    selectedAdjustments: IAccrualAdjustment[]
    offset: number
    limit: number
    openAddAdjustmentDialog: boolean
    openEditAdjustmentDialog: boolean
    selectedAdjustmentForEdit: IAccrualAdjustment
}

export default class Adjustments extends React.Component<IProps, IState> {
    constructor(props) {
        super(props)
        this.state = {
            adjustments: props.adjustments,
            selectedAdjustments: [],
            offset: 0,
            limit: 20,
            openAddAdjustmentDialog: false,
            openEditAdjustmentDialog: false,
            selectedAdjustmentForEdit: undefined,
        }
        autobind(this)
    }

    componentWillReceiveProps (newProps) {
        if(!utils.isEquivalentObjects(this.props.adjustments, newProps.adjustments)) {
            this.setState({ adjustments: newProps.adjustments })
        }
    }

    render() {
        return (
        <div style={{ marginTop: 25, }}>
            <div style={{ fontSize: 15, fontWeight: "bold", padding: 0 }}>
                {strings.Adjustments}
            </div>
            <div style={{ position: "relative" }}>
                <FloatingActionButton
                    data-intercom-target={"menu-AccountSettings-AccrualAdjustmentRules-Btn-Add"}
                    className="fixed-add"
                    style={{ right: 50, top: -30, zIndex: 998, }}
                    secondary
                    onTouchTap={() => this.setState({ openAddAdjustmentDialog: true })}
                >
                    <ContentAdd />
                </FloatingActionButton>
                <div style={{ padding: 20, paddingLeft: 0 }}>
                    {!this.state.adjustments.length ?
                        <div style={{ textAlign: "center", marginTop: 25, fontSize: 13, fontWeight: "bold", }}>
                            {strings.No_Adjustment_Found}
                        </div> :
                        <div>
                            <TableActionBar
                                rowSelectionCount={this.state.selectedAdjustments.length}
                                singleSelectedMessage={strings.Adjustment_Selected}
                                multipleSelectedMessage={strings.x_Adjustment_Selected}
                                searchText={""}
                                onDeleteClick={() => AppStateStore.setConfirmDialogContent({
                                    content: strings.Confirm_delete_adjustment,
                                    confirm: () => {
                                        this.props.deleteAdjustment(this.state.selectedAdjustments.map(item => item.Id))
                                        this.setState({ selectedAdjustments: [] })
                                    }
                                })}
                                readonly={false}
                            />
                            <AdjustmentsTable
                                readonly={this.props.readonly}
                                adjustments={this.state.adjustments}
                                selectedAdjustments={this.state.selectedAdjustments}
                                total={this.state.adjustments.length}
                                offset={this.state.offset}
                                limit={this.state.limit}
                                limitOptions={[20, 50, 100]}
                                onPageClick={offset => this.setState({ offset })}
                                onLimitChange={limit => this.setState({ offset: 0, limit })}
                                handleSelectedAdjustments={selectedAdjustments => this.setState({ selectedAdjustments })}
                                handleUpdate={selectedAdjustmentForEdit => {
                                    this.setState({ selectedAdjustmentForEdit }, () => {
                                        this.setState({ openEditAdjustmentDialog: true })
                                    })
                                }}
                            />
                        </div>
                    }
                </div>
                {this.state.openAddAdjustmentDialog &&
                <AdjustmentDialog
                    editAdjustment={false}
                    handleAddOrUpdate={adjustment => this.setState({ openAddAdjustmentDialog: false }, () => this.props.addOrUpdateAdjustment(adjustment, false))}
                    handleClose={() => this.setState({ openAddAdjustmentDialog: false })}
                />
                }
                {this.state.openEditAdjustmentDialog &&
                <AdjustmentDialog
                    editAdjustment
                    selectedAdjustment={this.state.selectedAdjustmentForEdit}
                    handleAddOrUpdate={adjustment => this.setState({ openEditAdjustmentDialog: false }, () => this.props.addOrUpdateAdjustment(adjustment, true))}
                    handleClose={() => this.setState({ openEditAdjustmentDialog: false })}
                />
                }
            </div>
        </div>
        )
    }
}